import { Pipe, PipeTransform } from '@angular/core';


@Pipe({ name: 'nestedData' })
export class NestedData implements PipeTransform {
  constructor() { }
  transform(dataItem: any, colField?: string) {
    if (colField && dataItem) {
      const properties = colField.split('.');
      return properties.reduce((prev: { [x: string]: any; }, curr: string | number) => prev && prev[curr], dataItem);
    }
    return;
  }
}
